import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('updateDefaultSettings', function updateDefaultSettings(settings) {
    var config = getUserConfiguration();
    config.UserOptions.GlobalReadingPanePositionReact = settings.GlobalReadingPanePositionReact;
    config.UserOptions.ConversationSortOrderReact = settings.ConversationSortOrderReact;
    config.UserOptions.GlobalListViewTypeReact = settings.GlobalListViewTypeReact;
});
//# sourceMappingURL=updateDefaultSettings.js.map